import prettyNumber from "../tables/functions/prettyNumber";

export default function YoY({ i, index, p, arr, type, tableType }) {
  const result = !type
    ? i?.[p] /
      arr?.find((a) => a?.year === i?.year - 1 && a?.month === i?.month)?.[p]
    : type === 1
    ? i?.[p] /
      arr?.find((a) =>
        i?.month === 1
          ? a?.year === i?.year - 1 && a?.month === 12
          : a?.year === i?.year && a?.month === i?.month - 1
      )?.[p]
    : 0;

  const percent = 100 * result;
  const rounded = Math.round(percent);

  const noCompare = tableType === "year" && index === 0;
  const color =
    rounded > 100
      ? "green"
      : rounded < 90
      ? "brown"
      : rounded < 100
      ? "#451c00"
      : "black";
  const bgColor =
    rounded > 100
      ? "lightgreen"
      : rounded < 90
      ? "rgb(255, 199, 162)"
      : rounded < 100
      ? "whitesmoke"
      : "transparent";
  return (
    <div
      style={{
        display: "flex",
        // color: color,
        backgroundColor: noCompare ? "transparent" : bgColor,
        justifyContent: "space-between",
      }}
    >
      {prettyNumber(i?.[p], {
        round: 0,
        postfix: " zł",
      })}
      {tableType === "day" || noCompare ? (
        <></>
      ) : (
        <div
          style={{
            //   color: "grey",
            opacity: 0.5,
            fontSize: "80%",
          }}
        >
          {rounded > 100 ? <>▲ </> : rounded < 100 ? <>▼ </> : <></>}
          <span>{rounded}%</span> {type === 1 ? <>mdm</> : <>rdr</>}
        </div>
      )}
    </div>
  );
}
